import "twin.macro";

import { ChangeEvent, useState } from "react";

import { useProblemOnPost } from "@/api/areas/mutations";
import { Post } from "@/api/areas/types";

import { Modal, SlideModalProps } from "./Modals";
import { Button } from "../buttons";
import Input from "../inputs";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../select";

const postErrorOptions = [
  { value: "Problème d'ouverture", label: "Problème d'ouverture" },
  { value: "Problème de fermeture", label: "Problème de fermeture" },
  { value: "other", label: "Décrivez l'erreur" },
];

const PostErrorModal = ({
  areaId,
  post,
  open,
  onClose,
}: { areaId: string; post: Post } & SlideModalProps) => {
  const postError = useProblemOnPost({ areaId: areaId, onClose: onClose });
  const [postErrorValue, setPostErrorValue] = useState("");
  const [postErrorDescription, setPostErrorDescription] = useState("");

  const handlePostErrorDescriptionChange = (
    e: ChangeEvent<HTMLInputElement>
  ) => {
    setPostErrorDescription(e.target.value);
  };
  const handlePostErrorSelected = async () => {
    await postError.mutateAsync({
      postName: post.name,
      problem:
        postErrorValue === "other" ? postErrorDescription : postErrorValue,
    });

    resetPostErrorValues();
  };

  const resetPostErrorValues = () => {
    setPostErrorDescription("");
    setPostErrorValue("");
  };

  return (
    <Modal tw="w-fit" open={open} onClose={onClose}>
      <h2 tw="text-lg font-semibold">Mettre le poteau {post.name} en erreur</h2>
      <div tw="flex flex-col gap-4 mt-4">
        <Select
          onValueChange={(value) => setPostErrorValue(value)}
          value={postErrorValue}
        >
          <SelectTrigger>
            <SelectValue tw="text-sm" placeholder="Sélectionnez le problème" />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              {postErrorOptions.map((error) => (
                <SelectItem key={error.value} value={error.value}>
                  {error.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
        {postErrorValue === "other" && (
          <Input
            onChange={handlePostErrorDescriptionChange}
            value={postErrorDescription}
          />
        )}
      </div>
      <div tw="flex gap-4 mt-4">
        <Button white onClick={onClose}>
          Annuler
        </Button>
        <Button primary onClick={handlePostErrorSelected}>
          Confirmer
        </Button>
      </div>
    </Modal>
  );
};

export default PostErrorModal;
